import { ProductListAnalyticsService } from '@analytics/feature';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { ProductWishlistService } from '@wishlist/feature';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'sd-cart-wishlist-button',
  imports: [SdvorIconComponent],
  templateUrl: './cart-wishlist-button.component.html',
  styleUrls: ['./cart-wishlist-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartWishlistButtonComponent {
  private productWishlistService = inject(ProductWishlistService);
  private productListAnalyticsService = inject(ProductListAnalyticsService, { optional: true });

  readonly productCode = input.required<string>();
  protected readonly hasEntry = toSignal(
    toObservable(this.productCode).pipe(switchMap((code) => this.productWishlistService.hasEntry(code))),
    { initialValue: false },
  );
  protected readonly loading = toSignal(
    toObservable(this.productCode).pipe(switchMap((code) => this.productWishlistService.getEntryLoading(code))),
    { initialValue: false },
  );

  addOrRemoveEntry(): void {
    const listName = this.productListAnalyticsService?.getListName() || '';

    this.productWishlistService.addOrRemoveEntry(this.productCode(), listName);
  }
}
